module.exports = __webpack_public_path__ + "static/media/room-7.e251c8d5.jpeg";